import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Page from '@src/components/page';
import xauCss from '@src/components/xfe-animation-css';
import Button from '@src/components/button';
import DownloadBtn from './components/download-btn';
import Store from './store';
import BackTopFooter from '@src/business-components/backtop-footer';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import redirect from '@src/utils/redirect-if-mobile-accress';
const styles = require('./index.less');
const lang = getLanguageByPath();
// PC端页面，如果是移动端访问，跳转到移动端页面
if (IS_MASTER_ENV) {
  redirect.redirectIfMobile(`/${lang}/download.html`, `/m/${lang}/index.html`);
} else {
  redirect.redirectIfMobile(`/zt/2025/03/21/index/${lang}/download.html`, `/m/2025/03/21/index/${lang}/index.html`);
}

const Download = ({ store }) => {
  const { layerData = {} } = store;
  const { download = {} } = layerData;
  store.use();

  return (
    <Page className={cx(styles.root, store.isActive && xauCss.AOS_ROOT, 'page-main')}>
      <Button style={{ backgroundImage: `url(${require('./images/' + lang + '/btn-back.png')})` }} className={styles.btnBack} onClick={store.back} />
      {/* 下载方式 */}
      <section className={styles.downloadMethod}>
        <div
          className={cx(styles.title, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })}
          style={{ backgroundImage: `url(${require(`./images/${lang}/title-download-method.png`)})` }}
        />
        <div className={cx(styles.divider, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(2) })} />
        <div className={cx(styles.content, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(3) })}>
          <DownloadBtn link={download.launcher_download_link} method="pc" />
          <DownloadBtn link={download.steam_download_link} method="steam" />
          <DownloadBtn link={download.xbox_download_link} method="xbox" />
        </div>
      </section>
      {/* 推荐配置 */}
      <section className={styles.recommConfig}>
        <div
          className={cx(styles.title, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })}
          style={{ backgroundImage: `url(${require(`./images/${lang}/title-recom-config.png`)})` }}
        />
        <div className={cx(styles.divider, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(2) })} />
        <div
          className={cx(styles.content, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(3) })}
          style={{ backgroundImage: `url(${require(`./images/${lang}/config-table.png`)})` }}
        />
      </section>
      {/* 下载须知 */}
      <section className={styles.downloadNote}>
        <div
          className={cx(styles.title, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })}
          style={{ backgroundImage: `url(${require(`./images/${lang}/title-download-note.png`)})` }}
        />
        <div className={cx(styles.divider, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(2) })} />
        <div className={cx(styles.content, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(3) })}>
          <img src={require(`./images/${lang}/download-note-text.png`)} alt="" />
        </div>
      </section>
      <BackTopFooter />
    </Page>
  );
};

export default wrapStore(Download, Store);
